import { Component, Input } from 'ng-metadata/core';
import * as angular from 'angular';
import './address.scss';
import { MediaContactAddress } from '../media-contact-document.model';

/**
 * @ngdoc directive
 * @name mwMediaContactDocumentAddress
 * @module mw.components.contentDocuments
 *
 * @param {object} [address] - Address Object (MediaContactDocumentAddress)
 *
 * @description
 * `<mw-media-contact-document-address>` is a component used to display the primary address.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 *
 *     <mw-media-contact-document-address address="::$ctrl.contact.primaryAddress">
 *     </mw-media-contact-document-address>
 *
 * </hljs>
 */

const template = `
    <span
        ng-if="::$ctrl.address.city"
        class="mw-media-contact-document-address"
        ng-bind-html="::$ctrl.address.city + ', ' + $ctrl.address.stateOrProvince + ' • ' + $ctrl.address.countryName">
    </span>
    <span
        ng-if="::!$ctrl.address.city && $ctrl.address.country"
        class="mw-media-contact-document-address"
        ng-bind-html="::$ctrl.address.country">
    </span>
`;

@Component({
    selector: 'mw-media-contact-document-address',
    template: template,
})

export class MediaContactDocumentAddressComponent {
    @Input('<') address: MediaContactAddress;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/address/address.component.ts